import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import InventarioSolicitudesGrid from './InventarioSolicitudesGrid.jsx';

/**
 * VEC-3317 — submódulo de Solicitudes de Stock del módulo de Inventario y Control de Stock v3.0.
 *
 * `/inventario/solicitudes` es la grilla de Pendientes y Finalizadas, que es el índice del
 * submódulo. Las dos vistas NO son dos rutas: son pestañas de la misma pantalla, porque son el mismo
 * recurso con otro filtro (`?vista=` del endpoint) y el usuario alterna entre ellas todo el tiempo.
 *
 * El Switch queda con una sola ruta a propósito, siguiendo el molde de InventarioStock.jsx: de acá
 * van a colgar las pantallas de VEC-3318 (confirmar despacho, registrar devolución) y el alta de
 * VEC-3319, cada una con su permiso propio.
 */
const InventarioSolicitudes = ({ match }) => {
  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="inventarioSolicitudes.header_solicitudes"
              defaultMessage="Solicitudes de Stock"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} render={(props) => <InventarioSolicitudesGrid {...props} />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(InventarioSolicitudes);
